import { render } from "./todoItem.vue?vue&type=template&id=ae13e790&scoped=true"
import script from "./todoItem.vue?vue&type=script&lang=js"
export * from "./todoItem.vue?vue&type=script&lang=js"

import "./todoItem.vue?vue&type=style&index=0&id=ae13e790&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae13e790"

export default script